class SwatchSliderComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = false;
    this.isInteractedWith = false;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');

    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;
  }

  initPages() {
    this.totalAmountOfSlides = this.querySelectorAll('.slideshow__slide');

    // Detect the select item
    let selectedSlide;
    this.sliderItems.forEach((item) => {
      const selectedItem = item.querySelector('input[type="radio"]:checked');
      if (selectedItem) {
        selectedSlide = item;
      }
    });

    if (selectedSlide) {
      this.slider.scrollTo(selectedSlide.offsetLeft, 0); // +1
    }

    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage >= this.totalPages;
    const lastPageHasOnlyOneSlide =
      this.sliderItemsToShow.length - (this.currentPage + Number(this.nextButton.dataset.step)) <= 1;

    //? For swatch slider, we also want to check if the last slide is actually visible
    const lastSlideIndex = this.totalAmountOfSlides.length - 1;
    const isLastSlideVisible =
      this.totalAmountOfSlides[lastSlideIndex] && this.isSlideVisible(this.totalAmountOfSlides[lastSlideIndex]);

    //? Hide prev button
    this.prevButton.setAttribute('aria-hidden', isFirstSlide);
    this.prevButton.style.display = isFirstSlide ? 'none' : 'block';
    if (isFirstSlide) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    //? Hide next button
    const hideNextButton = isLastSlide || lastPageHasOnlyOneSlide || isLastSlideVisible;
    this.nextButton.setAttribute('aria-hidden', hideNextButton);
    this.nextButton.style.display = hideNextButton ? 'none' : 'block';
    if (hideNextButton) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    if (this.currentSlideEl) {
      this.currentSlideEl.textContent = this.currentPage;
    }

    if (this.innerOverlayTriggers && this.innerOverlayTriggers.length > 0) {
      this.innerOverlayTriggers.forEach((trigger) => {
        trigger.dataset.isVisible = 'false';

        if (trigger.dataset.target.includes(`id-${this.currentPage}`)) {
          trigger.dataset.isVisible = 'true';
        }
      });
    }

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }
}

customElements.define('swatch-slider-component', SwatchSliderComponent);
